<template>
    <div id="appIndex">
        <loadingS v-if='loading'></loadingS>
        <template v-else>
            <div class="bg">
                <img src="./img/img_icon_01.png"
                     class="back"
                     @click="goBack" />
                <img src="./img/preheart_bg.png"
                     alt=" " />
            </div>
            <div class="text">
                <div class="title">活动攻略</div>
                <ul>
                    <li><span>1</span>活动时间：2025年7月01日00:00:00至2025年8月15日12:00:00</li>
                    <li><span>2</span>本活动短信邀请次数计入当月发作业次数。</li>
                    <li><span>3</span>活动期间，学生完成作业老师可以获得积分，积分越多，可抽取的奖品越多。</li>
                </ul>
            </div>
            <div class="fix-bottom"
                 @click="handlJump('/activity/2023shujia/timing')">
                <div class="icon-time">
                    <img src="./img/preheart_icon_time.png"
                         alt=" " />
                    <p>设置</p>
                </div>
                <span class="btn">设置定时邀请短信</span>
            </div>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
import loadingS from 'SRC/components/base/loadingS.vue';
export default {
    components: {
        loadingS
    },
    data () {
        return {
            loading: false,

        }
    },
    created () {
        //修改页面标题
        window.document.title = "暑假活动"

    },
    methods: {
        goBack () {
            if(this.inApp){
                this.appFunction("ys_finish");
            }else{
                this.$router.go(-1)
            }
        },
        handlJump (str) {
            this.$router.push(str)
        }
    },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#appIndex {
    background: #eff5ff;
    min-height: 737px;
    padding-bottom: 140px / $ppr;
    .bg {
        position: relative;
        .back {
            position: absolute;
            top: 0;
            left: 0;
            padding: 15px;
            width: 16px / $ppr;
            height: 31px / $ppr;
        }
    }
    .text {
        margin: -155px / $ppr 22px / $ppr 0 22px / $ppr;
        background: #fff;
        border-radius: 30px / $ppr;
        padding: 70px / $ppr 50px / $ppr 60px / $ppr 55px / $ppr;
        position: relative;
        .title {
            font-size: 38px / $ppr;
            font-weight: bold;
            color: #222;
            display: flex;
            justify-content: center;
            align-items: center;
            &:before,
            &:after {
                content: "";
                display: inline-block;
                width: 79px / $ppr;
                height: 4px / $ppr;
                margin: 0 10px / $ppr;
            }
            &:before {
                background: url("./img/preheart_title_after.png") no-repeat;
                background-size: 79px / $ppr 4px / $ppr;
            }
            &:after {
                background: url("./img/preheart_title_before.png") no-repeat;
                background-size: 79px / $ppr 4px / $ppr;
            }
        }
        ul {
            padding: 7px / $ppr 0;
        }
        li {
            margin: 37px 0;
            font-size: 24px / $ppr;
            color: #222;
            padding-left: 40px / $ppr;
            position: relative;
            line-height: 1.5;
            span {
                display: inline-block;
                width: 28px / $ppr;
                height: 28px / $ppr;
                line-height: 30px / $ppr;
                color: #fff;
                font-size: 22px / $ppr;
                background: #000;
                border-radius: 100%;
                text-align: center;
                position: absolute;
                top: 5px / $ppr;
                left: 0;
            }
        }
    }
    .fix-bottom {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 16px / $ppr 24px / $ppr;
        background: #fff;
        box-sizing: border-box;
        .icon-time {
            margin-right: 30px / $ppr;
            img {
                display: block;
                width: 36px / $ppr;
                height: 40px / $ppr;
                margin: 0 auto 5px / $ppr;
            }
            p {
                font-size: 22px / $ppr;
                color: #222;
            }
        }
        .btn {
            flex: 1;
            height: 86px / $ppr;
            line-height: 86px / $ppr;
            color: #fff;
            text-align: center;
            background: #fd302d;
            border-radius: 86px / $ppr;
            font-size: 32px / $ppr;
        }
    }
}
</style>